<div class="modal-overlay" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="success-modal" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="close-button" (click)="onClose()">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V24C28 26.2091 26.2091 28 24 28H4C1.79086 28 0 26.2091 0 24V4Z" fill="#F8F8FC"/>
            <path d="M18.4697 8.46967C18.7626 8.17678 19.2373 8.17678 19.5302 8.46967C19.8231 8.76256 19.8231 9.23732 19.5302 9.53022L15.0605 13.9999L19.5302 18.4697L19.582 18.5263C19.8223 18.8209 19.8048 19.2556 19.5302 19.5302C19.2556 19.8048 18.8209 19.8223 18.5263 19.582L18.4697 19.5302L13.9999 15.0605L9.53022 19.5302C9.23732 19.8231 8.76256 19.8231 8.46967 19.5302C8.17678 19.2373 8.17678 18.7626 8.46967 18.4697L12.9394 13.9999L8.46967 9.53022C8.17678 9.23732 8.17678 8.76256 8.46967 8.46967C8.76256 8.17678 9.23732 8.17678 9.53022 8.46967L13.9999 12.9394L18.4697 8.46967Z" fill="#15172E"/>
            </svg>
            
    </button>

    <!-- Success Illustration -->
    <div class="success-illustration">
     <img src="assets/images/appointment/Illustrations.svg" alt="Success Illustration">
    </div>

    <div class="success-content">
      <!-- Title -->
      <h2 class="success-title">{{ title }}</h2>

      <!-- Description - Only show if no order details -->
      <!-- <p class="success-description"  style="margin-top: 5px;" *ngIf="description">{{ description }}</p> -->

      <!-- Order Details Layout - Show when order details are available -->
      <!-- <div class="order-details-container" *ngIf="hasOrderDetails"> -->
      <div class="order-details-container" >
        <p class="order-description">The order has been successfully completed. The customer may now proceed to the car wash.</p>
        
        <div class="order-details-grid">
          <div class="order-detail-item" *ngIf="packageName">
            <div class="order-detail-label">CAR WASH PACKAGE</div>
            <div class="order-detail-value" *ngIf="packageName">{{ packageName || 'N/A' }}</div>
          </div>
          
          <div class="order-detail-item" *ngIf="customerName">
            <div class="order-detail-label">CUSTOMER NAME</div>
            <div class="order-detail-value" *ngIf="customerName">{{ customerName || 'N/A' }}</div>
          </div>
          
          <div class="order-detail-item" *ngIf="vehicleDisplay">
            <div class="order-detail-label">VEHICLE</div>
            <div class="order-detail-value" *ngIf="vehicleDisplay">{{ vehicleDisplay || 'N/A' }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Button -->
    <div class="success-button">
        <button class="btn btn-primary btn-large" (click)="onPrimaryAction()">
            {{ buttonText }}
          </button>
    </div>
  </div>
</div>
